import { makeStyles, tokens } from '@fluentui/react-components';
import { LookupEdit, type LookupFilterContext } from '@powerportalspro/react-fluent';

const useStyles = makeStyles({
  stack: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
});

// The contacts of the account chosen above; every contact until one is.
function contactsOfAccount({ record }: LookupFilterContext) {
  const accountId = (record.properties?.['ppp_parentcustomerid'] as { value?: string } | undefined)?.value;
  return accountId
    ? `<filter><condition attribute="parentcustomerid" operator="eq" value="${accountId}" /></filter>`
    : null;
}

export function LookupEditFilterSample() {
  const styles = useStyles();
  return (
    <div className={styles.stack}>
      <LookupEdit columnName="ppp_parentcustomerid" targetTables={['account']} />
      <LookupEdit columnName="ppp_primarycontact" filterProvider={contactsOfAccount} />
    </div>
  );
}
